import { EntityRepository, Repository } from "typeorm";
import { RmRackPosition } from "../rm-rack-position.entity";

@EntityRepository(RmRackPosition)
export class RmRackPositionRepository extends Repository<RmRackPosition>{
}